import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-saveData",
  "use": "icon-saveData-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-saveData\"><defs><style type=\"text/css\"></style></defs><path d=\"M848 864H176a96 96 0 0 1-96-96V256a96 96 0 0 1 96-96h672a96 96 0 0 1 96 96v512a96 96 0 0 1-96 96zM704 768h144V688H704v80z m0-176h144V512H704v80z m144-176V336H704v80h144zM416 768h192V688H416v80z m0-176h192V512H416v80z m192-176V336H416v80h192zM176 768h144V688H176v80z m0-176h144V512H176v80z m144-176V336H176v80h144z\" fill=\"\" p-id=\"3857\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/saveData.svg
// module id = gBcG
// module chunks = 111